import { defineStore } from 'pinia';

import { FormValues } from '@/components/pages/Admins/SignUp/Container.vue';
import { Admin } from '@/types/admin';
import { apiGet, apiPost } from '@/utils/api';

export const useCurrentAdminStore = defineStore('currentUserAdmin', {
  state: () => ({
    user: null as Admin | null,
  }),
  actions: {
    // ログイン状態を確認する
    async isLoggedIn() {
      const { data } = await apiGet<Admin>('/api/admin/me');

      if (data) {
        this.user = data;
      }

      return !!data;
    },
    // 仮登録する
    async temporaryRegistration(email: string) {
      return await apiGet('/sanctum/csrf-cookie').then(
        async () => await apiPost('/api/admin/registration', { email })
      );
    },
    // メール認証のトークンをチェックする
    async registrationVerify(token: string) {
      return await apiPost('/api/admin/registration/verify', { token });
    },
    //  ログインをする
    async login(email: string, password: string) {
      return await apiGet('/sanctum/csrf-cookie').then(async () => {
        const params = { email, password };
        const data = await apiPost<Admin>('/api/admin/login', params);

        if (data.success) {
          this.user = data.data;
        }

        return data;
      });
    },
    //  会員登録をする
    async register(formValues: FormValues, token: string) {
      return await apiGet('/sanctum/csrf-cookie').then(async () => {
        const data = await apiPost<Admin>('/api/admin/me', {
          ...formValues,
          token,
        });

        return data;
      });
    },
    // パスワード再設定メール送信
    async sendPasswordResetLink(email: string) {
      const params = { email };
      return await apiPost('/api/admin/password/reset-request', params);
    },
    // パスワード再設定
    async resetPassword(
      userId: number,
      token: string,
      password: string,
      password_confirmation: string
    ) {
      const params = {
        id: userId,
        token,
        password,
        password_confirmation,
      };

      return await apiPost('/api/admin/password/reset', params);
    },
    // ログアウト
    async logout() {
      const res = await apiPost('/api/admin/logout');

      if (res.success) {
        this.user = null;
      }

      return res;
    },
  },
});
